import InView from 'inview';
import { CountUp } from 'countup.js/dist/countUp.umd';

export class Stat {
	isCounting = false;

	hasAnimated = false;

	constructor(el) {
		if (!el) return;

		this.el = el;
		this.number = this.parseNumber();
		this.block = this.el.closest('.wp-block-embark-stat__inner_homepage_hero');

		this.initializeCountUp();
		this.setupInViewObserver();

		// Trigger immediately in editor context
		if (this.isInEditor()) {
			setTimeout(() => this.triggerAnimations(), 300);
		}
	}

	isInEditor() {
		return document.body.classList.contains('wp-admin') || document.body.classList.contains('block-editor-page');
	}

	parseNumber() {
		const hiddenSpan = this.el.closest('.wp-block-embark-stat__value_homepage_hero')?.querySelector('.hidden');
		return hiddenSpan
			? parseFloat(hiddenSpan.textContent.trim())
			: parseFloat(this.el.dataset.number);
	}

	initializeCountUp() {
		const decimalPlaces = String(this.number).includes('.')
			? String(this.number).split('.')[1].length
			: 0;

		this.countUpOptions = {
			decimalPlaces,
			suffix: this.el.textContent.includes('%') ? '%' : '',
			duration: 1.5,
			startVal: 0,
		};

		try {
			this.countUp = new CountUp(this.el, this.number, this.countUpOptions);
			if (this.countUp.error) throw this.countUp.error;
		} catch (e) {
			console.error('CountUp initialization failed:', e);
			this.countUp = null;
		}
	}

	setupInViewObserver() {
		if (this.isInEditor()) return;

		this.inView = InView(this.el, (isInView) => {
			if (isInView) this.triggerAnimations();
		}, {
			offset: 100,
			defer: false,
		});
	}

	triggerAnimations() {
		if (this.hasAnimated) return;
		this.hasAnimated = true;

		// Start count animation
		if (this.countUp) {
			this.countUp.start();
		} else {
			this.el.textContent = this.number + (this.countUpOptions.suffix || '');
		}
	}

	destroy() {
		if (this.inView) this.inView.destroy();
	}
}

export function initStats() {
	// Clean up previous instances
	if (window.embarkStats) {
		window.embarkStats.forEach((stat) => stat.destroy());
	}

	const statEls = [...document.querySelectorAll('.js-counter')];
	if (!statEls.length) return;

	window.embarkStats = statEls.map((el) => new Stat(el));

	// Gutenberg editor compatibility
	if (typeof wp !== 'undefined' && wp.data) {
		wp.data.subscribe(() => {
			setTimeout(initStats, 100);
		});
	}
}

// Initialize with multiple fallbacks
const init = () => {
	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		setTimeout(initStats, 100);
	} else {
		document.addEventListener('DOMContentLoaded', initStats);
	}
};

// Expose for manual control
window.embarkInitStats = initStats;

// Start initialization
init();

document.addEventListener('DOMContentLoaded', () => {
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const circle = entry.target.querySelector('.stats_pie');
				if (circle) {
					circle.classList.add('animating');
				}
				// Once animated, we can stop observing
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.1, // Trigger when at least 10% of the element is visible
	});

	// Observe all stat containers
	document.querySelectorAll('.stats_stat__xAxeK').forEach((stat) => {
		observer.observe(stat);
	});
});
